"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WILL_START = exports.STOPPING = exports.STARTING = exports.IDLE = exports.DICTATING = void 0;
var IDLE = 0;
exports.IDLE = IDLE;
var WILL_START = 1;
exports.WILL_START = WILL_START;
var STARTING = 2;
exports.STARTING = STARTING;
var DICTATING = 3;
exports.DICTATING = DICTATING;
var STOPPING = 4;
exports.STOPPING = STOPPING;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJJRExFIiwiZXhwb3J0cyIsIldJTExfU1RBUlQiLCJTVEFSVElORyIsIkRJQ1RBVElORyIsIlNUT1BQSU5HIl0sInNvdXJjZVJvb3QiOiJjb3JlOi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2NvbnN0YW50cy9EaWN0YXRlU3RhdGUuanMiXSwic291cmNlc0NvbnRlbnQiOlsiY29uc3QgSURMRSA9IDA7XG5jb25zdCBXSUxMX1NUQVJUID0gMTtcbmNvbnN0IFNUQVJUSU5HID0gMjtcbmNvbnN0IERJQ1RBVElORyA9IDM7XG5jb25zdCBTVE9QUElORyA9IDQ7XG5cbmV4cG9ydCB7IERJQ1RBVElORywgSURMRSwgU1RBUlRJTkcsIFNUT1BQSU5HLCBXSUxMX1NUQVJUIH07XG4iXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLElBQU1BLElBQUksR0FBRyxDQUFDO0FBQUNDLE9BQUEsQ0FBQUQsSUFBQSxHQUFBQSxJQUFBO0FBQ2YsSUFBTUUsVUFBVSxHQUFHLENBQUM7QUFBQ0QsT0FBQSxDQUFBQyxVQUFBLEdBQUFBLFVBQUE7QUFDckIsSUFBTUMsUUFBUSxHQUFHLENBQUM7QUFBQ0YsT0FBQSxDQUFBRSxRQUFBLEdBQUFBLFFBQUE7QUFDbkIsSUFBTUMsU0FBUyxHQUFHLENBQUM7QUFBQ0gsT0FBQSxDQUFBRyxTQUFBLEdBQUFBLFNBQUE7QUFDcEIsSUFBTUMsUUFBUSxHQUFHLENBQUM7QUFBQ0osT0FBQSxDQUFBSSxRQUFBLEdBQUFBLFFBQUEifQ==